<template>
  <div id="mvdsAlert">
    <accessible-dialog
      width="auto"
      max-width="600"
      v-model="show"
      :persistent="isPersistent"
      aria-label="Alert"
    >
      <v-card
        class="d-flex flex-column justify-center align-center pa-4"
        :min-width="minWidth"
        :max-width="maxWidth"
      >
        <v-icon
          size="100px"
          :color="
            iconColorMap[variant] !== undefined
              ? iconColorMap[variant]
              : 'secondary'
          "
          >{{ alertIcon }}</v-icon
        >
        <v-card-title class="font-weight-bold justify-center">{{
          title
        }}</v-card-title>
        <div class="description" v-if="description">
          {{ description }}
        </div>
        <div class="description" v-if="description2">
          {{ description2 }}
        </div>

        <v-card-actions class="d-flex justify-space-around">
          <template v-if="['', null, undefined].includes(actions)">
            <v-btn
              text
              color="secondary"
              @click="store.dispatch('hideGlobalAlert')"
              >{{ englishLang.globalAlertOkayButton }}</v-btn
            >
          </template>
          <template v-else>
            <v-btn
              v-for="action in actions"
              :key="action.text"
              text
              @click="action.handler"
              :color="action.color"
              class="alert-button"
            >
              {{ action.text }}
            </v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </accessible-dialog>
  </div>
</template>

<script>
import AccessibleDialog from "@/components/AccessibleDialog.vue";
import store from "@/store";
import EnglishLang from "../../public/languages/English.json";

export default {
  components: { AccessibleDialog },
  props: {
    icon: {
      type: String,
      validator: val => {
        return val.includes("mdi-");
      },
      required: false
    },
    variant: { type: String, default: "info" },
    value: { type: Boolean, required: true },
    title: { type: String, required: false },
    description: { type: String, required: false },
    description2: { type: String, required: false },
    isPersistent: { type: Boolean, default: true },
    maxWidth: { type: String, default: "40vw", required: false },
    minWidth: { type: String, default: "300", required: false },
    actions: { type: Array, required: false }
  },
  data() {
    return {
      englishLang: EnglishLang,
      iconColorMap: {
        error: "danger",
        success: "success",
        warning: "warning",
        info: "primary"
      },
      store: store
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      }
    },
    alertIcon() {
      let icon = "";
      switch (this.variant) {
        case "info":
          icon = this.icon ?? "mdi-alert-circle";
          break;
        case "warning":
          icon = this.icon ?? "mdi-alert";
          break;
        case "error":
          icon = this.icon ?? "mdi-alert-circle";
          break;
        case "success":
          icon = this.icon ?? "mdi-check-circle";
          break;
      }

      return icon;
    }
  }
};
</script>

<style scoped>
.v-card :deep(.v-card__title) {
  font-size: 30px !important;
  word-break: normal;
}

.description {
  font-family: Verdana, Geneva, Tahoma, sans-serif !important;
  font-size: 12px !important;
  color: #545454 !important;
  white-space: pre-line;
}

.v-card :deep(.v-card__text) {
  font-family: Verdana, Geneva, Tahoma, sans-serif !important;
  font-size: 18px !important;
  color: #545454 !important;
  padding-top: 20px !important;
  white-space: pre-line;
}

.v-card__actions :deep(.v-btn) {
  padding: 10px 30px !important;
  font-size: 16px !important;
}
#mvdsAlert {
  z-index: 3768;
}
</style>
